import VideoCompiler     from 'descriptor/video_compiler';

const Compiler = function(descriptor, videoUrlFragment) {
  this.descriptor = descriptor;
  this.videoUrlFragment  = videoUrlFragment;
};

Compiler.prototype = {
  compile() {
    const inIndex = this.descriptor.videos.findIndex((video) => video.videoUrlFragment === this.videoUrlFragment);
    if(!isNaN(inIndex) && inIndex !== -1) {
      this.descriptor.initialIndex = (inIndex > this.descriptor.videos.length || inIndex < 0)? 0: inIndex;
    } else if(this.descriptor.specialtyTitle === this.videoUrlFragment) {
      this.descriptor.initialIndex = -1;
    } else {
      this.descriptor.initialIndex = 0;
    }
    this.mediaCompiler      = new VideoCompiler(this.descriptor.videos, this.descriptor.ccInfo);
    this.descriptor.isVideo = true;
    this.mediaCompiler.compile();
    this.descriptor.videos = this.mediaCompiler.getVideos();
    return this;
  },
  getDescriptor() {
    return this.descriptor;
  }
};

export default Compiler;



/** WEBPACK FOOTER **
 ** ./modules/descriptor/compiler.js
 **/